import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { AppPagesItem, Followers } from '@kitch/data-access/models';
import { ProfilesService, TokenService } from '@kitch/data-access/services';

@UntilDestroy()
@Component({
  selector: 'app-favorites-clubs',
  templateUrl: './favorites-clubs.component.html',
  styleUrls: ['./favorites-clubs.component.scss', './../favorites-shared.scss'],
})
export class FavoritesClubsComponent implements OnInit, OnDestroy {
  favoritesClubs: Followers[];
  isLoading: boolean;
  profileId: string;

  constructor(
    private profilesService: ProfilesService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.profileId = this.tokenService.getProfileId();

    this.getFavoritesChannelsInfo().subscribe();
  }

  ngOnDestroy() {}

  private getFavoritesChannelsInfo(): Observable<AppPagesItem<Followers>> {
    return this.profilesService.getPurchasedClubs(this.profileId)
      .pipe(
        untilDestroyed(this),
        tap((favoritesClubs) => {
          this.favoritesClubs = favoritesClubs.results;
        }),
        finalize(() => this.isLoading = false),
      );
  }
}
